import { is } from '@convenia/helpers'
import { DIRECTIVE_HOOKS } from '@convenia/utils/modules/vue3Migration'

import getComponent from './getComponent'

const isArgObj = val => is(val, 'Object')
  && [ 'ev', 'fn' ].every(key => Object.keys(val || {}).includes(key) && !!val[key])

export default {
  [DIRECTIVE_HOOKS.BEFORE_MOUNT] (el, binding, vnode) {
    const { value } = binding
    const component = getComponent({ binding, vnode })

    const handler = e => {
      if (!el.contains(e.target) && el !== e.target) el.__vueClickOutsideFn__(e)
    }

    el.__vueClickOutside__ = handler
    el.__vueClickOutsideFn__ = isArgObj(value) ? value.fn.bind(component) : value.bind(component)
    el.__vueClickOutsideEv__ = isArgObj(value) ? value.ev : 'click'

    document.addEventListener(el.__vueClickOutsideEv__, handler)
  },

  [DIRECTIVE_HOOKS.UNMOUNTED] (el) {
    document.removeEventListener(el.__vueClickOutsideEv__, el.__vueClickOutside__)

    el.__vueClickOutside__ = null
    el.__vueClickOutsideFn__ = null
    el.__vueClickOutsideEv__ = null
  }
}
